
import Assert from "tbAssert";

import ngSanitize from "angular-sanitize";
import ngAnimate from "angular-animate";
import ngAria from "angular-aria";
import uiBootstrap from "angular-ui-bootstrap";
import uiRouter from "@uirouter/angularjs";

import TrackingEventSearchModuleConstants from "tbClient/views/tracking-event-search/Constants";

const mLogSvc = new WeakMap();
const mTimeoutSvc = new WeakMap();
const mUiRouterStateSvc = new WeakMap();

const mSearchString = new WeakMap();
const mIsInSearchMode = new WeakMap();
const mSearchButtonClasses = new WeakMap();

const mWidgetWrapperClasses = new WeakMap();

class NavbarSearchWidgetController {
    constructor($scope, $log, $timeout, $state) {
        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Scope Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert($timeout != null, "Assertion Failure: Missing Timeout Service Dependency");
        Assert.StrictAssert($state != null, "Assertion Failure: Missing UI Router State Service Dependency");

        mLogSvc.set(this, $log);
        mTimeoutSvc.set(this, $timeout);
        mUiRouterStateSvc.set(this, $state);

        mSearchString.set(this, "");
        mIsInSearchMode.set(this, false);
        mSearchButtonClasses.set(this, {
            btn: true,
            "btn-link": true,
            "btn-primary": false,
            "tb-search-widget-btn": true
        });

        $scope.$watch(
            () => this.isInSearchMode,
            (newVal, oldVal) => {
                if (newVal !== oldVal) {
                    this._setSearchButtonClasses();
                }
            }
        );
    }

    _setSearchButtonClasses() {
        mTimeoutSvc.get(this)(
            () => {
                this.searchButtonClasses["btn-link"] = (!this.isInSearchMode);
                this.searchButtonClasses["btn-primary"] = (this.isInSearchMode);
            },
            0
        );
    }

    _doSearch() {
        if (this.searchString.length > 0) {
            let eventSearchString = this.searchString;
            mUiRouterStateSvc.get(this).go(
                TrackingEventSearchModuleConstants.rootStateName,
                { searchQuery: eventSearchString, fromNavBar: true }
            );
        }

        this.isInSearchMode = false;
        this.searchString = "";
    }

    _showSearch() {
        this.isInSearchMode = true;
        let searchInputElement = angular.element("#eventSearchInput");

        mTimeoutSvc.get(this)(() => {
            searchInputElement.focus();
        }, 0);
    }

    get searchString() {
        return mSearchString.get(this);
    }

    set searchString(updatedSearchString) {
        mSearchString.set(this, updatedSearchString);
    }

    get isInSearchMode() {
        return mIsInSearchMode.get(this);
    }

    set isInSearchMode(updatedVal) {
        mIsInSearchMode.set(this, updatedVal);
    }

    get searchButtonClasses() {
        return mSearchButtonClasses.get(this);
    }

    get wrapperClasses() {
        return mWidgetWrapperClasses.get(this);
    }

    set wrapperClasses(updatedVal) {
        mWidgetWrapperClasses.set(this, updatedVal);
    }

    searchAction(e) {
        e.preventDefault();

        if (this.isInSearchMode === true) {
            this._doSearch();
        }
        else {
            this._showSearch();
        }
    }

    searchOnSubmit(e) {
        e.preventDefault();

        this._doSearch();
    }
}

NavbarSearchWidgetController.$inject = [ "$scope", "$log", "$timeout", "$state" ];

NavbarSearchWidgetController.template = require("./NavbarSearchWidget.tpl.html");
NavbarSearchWidgetController.controllerAs = "tbSearchWidget";

NavbarSearchWidgetController.dependencies = [
    ngSanitize,
    ngAnimate,
    ngAria,
    uiBootstrap,
    uiRouter
];

export default NavbarSearchWidgetController;



//////////////////
// WEBPACK FOOTER
// ./src/views/main-page/MainPageNavbar/NavbarSearchWidget/NavbarSearchWidgetController.js
// module id = Twa/
// module chunks = 1